import { DestroyRef, Directive, ElementRef, HostListener, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { BehaviorSubject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

import { TableConstants } from '@shared/constants/table.constants';

const LG_BREAKPOINT = 2000;

@Directive({
  selector: '[auxGridDynamicHeight]',
  standalone: true,
})
export class GridDynamicHeightDirective implements OnInit {
  private readonly destroyRef = inject(DestroyRef);
  private elementRef = inject(ElementRef);

  innerWidth$ = new BehaviorSubject(0);

  ngOnInit() {
    this.innerWidth$.next(window.innerWidth);

    this.innerWidth$.pipe(debounceTime(200), takeUntilDestroyed(this.destroyRef)).subscribe(() => {
      this.updateGridLayout();
    });
  }

  @HostListener('window:resize', ['$event'])
  onResize() {
    this.innerWidth$.next(window.innerWidth);
  }

  updateGridLayout() {
    this.elementRef.nativeElement.style.height =
      this.innerWidth$.getValue() > LG_BREAKPOINT
        ? TableConstants.SCROLL.MAX_TABLE_HEIGHT_LG
        : TableConstants.SCROLL.MAX_TABLE_HEIGHT;
  }
}
